import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function maxShowText(
    text: string,
    textLength: number,
    toggle: boolean,
  ): string {
    let result = "";
    if (text.length > textLength && toggle) {
      result = `${text.slice(0, textLength)}...`;
    } else {
      result = `${text}`;
    }
    return result;
  }

  return {
    maxShowText,
  };
}
